export default {
	computed: {
		current_acount_payment_method_id() {
			return this.$store.state.vender.current_acount_payment_method_id
		},
		client() {
			return this.$store.state.vender.client
		},
		omitir_en_cuenta_corriente() {
			return this.$store.state.vender.omitir_en_cuenta_corriente
		},
		selected_payment_methods() {
			return this.$store.state.vender.selected_payment_methods
		},
		hay_mas_de_un_metodo_de_pago() {
			return this.selected_payment_methods.length 
		},
	},
	methods: {
		check_payment_methods() {

			return true

			if (this.hay_mas_de_un_metodo_de_pago
				&& (
					!this.client 
					|| this.omitir_en_cuenta_corriente
				)
			) {

				if (!this.check_sobrante_a_repartir()) {
					return false 
				} 
			} 
			return true
		},
		check_sobrante_a_repartir(){

			if (this.sobrante_a_repartir != 0) {

				this.$toast.error('Seleccione Metodo de Pago', {
					duration: 5000
				})

				return false
			} 

			return true
		},
	}
}